import selectIcon from "./selecticon.png"
import { Box } from "theme-ui"
import { IDeviceTreeGroupElement, IDeviceGroup } from "@types"
import { useEffect, useState } from "react"
import { compareDeviceGroupElements } from "utils/assert"

interface props {
 group: IDeviceGroup
 openDeviceGroup: number[]
 toggleOpenDeviceGroup: (_id: number) => void

 selectedDeviceTreeGroupElements: IDeviceTreeGroupElement[]
 setSelectedDeviceTreeGroupElements: (..._arg: any[]) => void
}

export const SideBarSubCategory = ({
 group,
 toggleOpenDeviceGroup,
 openDeviceGroup,
 selectedDeviceTreeGroupElements,
 setSelectedDeviceTreeGroupElements,
}: props) => {
 const [checkAnyDeviceIsSelectedInThisGroup, setCheckAnyDeviceIsSelectedInThisGroup] =
  useState<boolean>(false)
 const allDeviceTreeGroupElementsOfThisGroupInSelectedList = selectedDeviceTreeGroupElements.filter(
  (device: IDeviceTreeGroupElement) =>
   !!group.devices.find(
    (deviceObj: IDeviceTreeGroupElement) =>
     device.device_id === deviceObj.device_id &&
     device.group_id === deviceObj.group_id &&
     device.server_id === deviceObj.server_id,
   ),
 )
 const isAllDeviceTreeElementsSelected: boolean = compareDeviceGroupElements(
  group.devices,
  allDeviceTreeGroupElementsOfThisGroupInSelectedList,
 )

 useEffect(() => {
  if (isAllDeviceTreeElementsSelected) {
   setCheckAnyDeviceIsSelectedInThisGroup(false)
  } else {
   let helperState = false
   // eslint-disable-next-line
   group.devices.forEach((device: IDeviceTreeGroupElement) => {
    if (
     !!selectedDeviceTreeGroupElements.find(
      (deviceObj: IDeviceTreeGroupElement) =>
       deviceObj.device_id === device.device_id &&
       deviceObj.group_id === device.group_id &&
       deviceObj.server_id === device.server_id,
     )
    ) {
     helperState = true
    }
   })
   if (helperState) {
    setCheckAnyDeviceIsSelectedInThisGroup(true)
   } else {
    setCheckAnyDeviceIsSelectedInThisGroup(false)
   }
  }
  // eslint-disable-next-line
 }, [selectedDeviceTreeGroupElements])
 const toggleSelectDeviceGroup = () => {
  if (isAllDeviceTreeElementsSelected) {
   let duplicateSelectedDeviceTreeGroupElements = [...selectedDeviceTreeGroupElements]
   group.devices.forEach((deviceObj: IDeviceTreeGroupElement) => {
    duplicateSelectedDeviceTreeGroupElements = duplicateSelectedDeviceTreeGroupElements.filter(
     (device: IDeviceTreeGroupElement) =>
      device.device_id !== deviceObj.device_id ||
      device.group_id !== deviceObj.group_id ||
      device.server_id !== deviceObj.server_id,
    )
   })
   setSelectedDeviceTreeGroupElements([...duplicateSelectedDeviceTreeGroupElements])
  } else {
   setSelectedDeviceTreeGroupElements([...selectedDeviceTreeGroupElements, ...group.devices])
  }
 }

 const selectOnlyThisDeviceGroupDevices = () => {
  setSelectedDeviceTreeGroupElements([...group.devices])
 }

 return (
  <div className="subcategory pl-8 gap-2 flex items-center py-2 w-11/12 mx-auto animate-move-card">
   <div
    onClick={() => toggleOpenDeviceGroup(group.group_id)}
    className="bg-golden border-yellow border h-5 w-5 rounded flex justify-center items-center cursor-pointer"
   >
    <img
     className={`${openDeviceGroup.includes(group.group_id) ? "rotate-360" : "rotate-180"}`}
     src={selectIcon}
     alt="selectIcon"
     loading="lazy"
    />
   </div>
   <Box color="text">
    {checkAnyDeviceIsSelectedInThisGroup ? (
     <div className="flex items-center gap-2">
      <span
       className="bg-golden h-5 w-5 rounded border-yellow border flex justify-center items-center cursor-pointer"
       onClick={() => toggleSelectDeviceGroup()}
      >
       <div className="w-[8px] h-[2px] bg-black"></div>
      </span>
      <label
       className="font-semibold cursor-pointer font-sm Jakarta-font"
       onClick={() => selectOnlyThisDeviceGroupDevices()}
      >
       {group.group_name}
      </label>
     </div>
    ) : (
     <div className="flex gap-2 items-center">
      <span
       className="bg-golden h-5 w-5 rounded border-yellow border flex justify-center items-center cursor-pointer"
       onClick={() => toggleSelectDeviceGroup()}
      >
       {isAllDeviceTreeElementsSelected && <span>✔</span>}
      </span>
      <label
       className="font-semibold cursor-pointer font-sm Jakarta-font"
       onClick={() => {
        selectOnlyThisDeviceGroupDevices()
       }}
      >
       {group.group_name}
      </label>
     </div>
    )}
   </Box>
  </div>
 )
}
